
<script>
/**
 * Forgot-password component
 */
export default {
  name: "ForgotPassword",
};
</script>

<template>
  <div>
    <div class="account-home-btn d-none d-sm-block">
      <a href="/" class="text-white">
        <i class="mdi mdi-home h1"></i>
      </a>
    </div>

    <section class="bg-account-pages height-100vh">
      <div class="display-table">
        <div class="display-table-cell">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-5">
                <div class="card account-card">
                  <div class="card-body">
                    <div class="text-center mt-3">
                      <h3 class="font-weight-bold">
                        <a href="/" class="text-dark text-uppercase account-pages-logo">CEPTE IK</a>
                      </h3>
                      <p class="text-muted">Şifreni Sıfırla</p>
                    </div>
                    <div class="p-3">
                      <div
                        class="alert alert-warning text-center"
                        role="alert"
                      >E-posta adresinizi girerek, adresinize yollanan linkten şifrenizi değiştirebilirsiniz.</div>
                      <form>
                        <div class="form-group">
                          <label for="email">E-Posta</label>
                          <input
                            type="password"
                            class="form-control"
                            id="email"
                            placeholder="Mail adresiniz"
                          />
                        </div>

                        <div class="mt-3">
                          <button type="submit" class="btn btn-custom btn-block">Şifremi Gönder</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <!-- end card -->
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
        </div>
      </div>
    </section>
    <!-- end account-pages  -->
  </div>
</template>
